import { render } from "./SideBarSales.vue?vue&type=template&id=7f7930cd&scoped=true"
import script from "./SideBarSales.vue?vue&type=script&lang=js"
export * from "./SideBarSales.vue?vue&type=script&lang=js"

import "./SideBarSales.vue?vue&type=style&index=0&id=7f7930cd&scoped=true&lang=css"

import exportComponent from "/home/clients/74415e597e89acaa30448f5e983fc289/sites/poses.renosolu.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7930cd"]])

export default __exports__